interface ICalendarIconV2Props {
	size?: number;
	color?: string;
}

export function CalendarIconV2({
	size = 24,
	color = 'currentColor',
}: ICalendarIconV2Props) {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 18 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M12.6914 0C13.0737 0 13.3837 0.312381 13.3837 0.697674V1.86047H15.4615C16.8635 1.86047 18 3.0058 18 4.4186V17.4419C18 18.8547 16.8635 20 15.4615 20H2.53846C1.13653 20 0 18.8547 0 17.4419V4.4186C0 3.0058 1.13653 1.86047 2.53846 1.86047H4.61538V0.697674C4.61538 0.312381 4.92536 0 5.30769 0C5.68982 0.000245391 6 0.312532 6 0.697674V1.86047H11.9991V0.697674C11.9991 0.312381 12.3091 0 12.6914 0ZM1.38462 8.83721V17.4419C1.38462 18.0841 1.90119 18.6047 2.53846 18.6047H15.4615C16.0988 18.6047 16.6154 18.0841 16.6154 17.4419V8.83721H1.38462ZM2.53846 3.25581C1.90119 3.25581 1.38462 3.77639 1.38462 4.4186V7.44186H16.6154V4.4186C16.6154 3.77639 16.0988 3.25581 15.4615 3.25581H13.3837V4.4186C13.3837 4.8039 13.0737 5.11628 12.6914 5.11628C12.3091 5.11628 11.9991 4.8039 11.9991 4.4186V3.25581H6V4.4186C6 4.80375 5.68982 5.11603 5.30769 5.11628C4.92536 5.11628 4.61538 4.8039 4.61538 4.4186V3.25581H2.53846Z"
				fill={color}
			/>
		</svg>
	);
}
